import { postsHandlers } from '@/test/msw/handlers/posts'
import { transcriptHandlers } from '@/test/msw/handlers/transcript'

export const handlers = [...postsHandlers, ...transcriptHandlers]
